import Api from 'Helpers/api';

const Products = {
	fetch: async () => {
		const response = await Api.call('get', '/products');
		return response.data;
	},
	create: async params => {
		const response = await Api.call('post', '/products', params);
		return response.data;
	}
};

export default Products;
